import React from 'react';
import { Link } from 'react-router-dom';
import LanguageSelector from '../settings/LanguageSelector';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="bg-white dark:bg-gray-800 shadow-inner py-4 mt-auto">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <Link to="/" className="text-xl font-bold text-domired-600">
              DomiRed
            </Link>
            <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
              {t('copyright')} {new Date().getFullYear()} Domired.top - {t('tagline')}
            </p>
          </div>
          <div className="flex flex-col md:flex-row items-center space-y-3 md:space-y-0">
            <div className="flex space-x-4 mb-3 md:mb-0 md:mr-6">
              <Link to="/about" className="text-sm text-gray-600 dark:text-gray-400 hover:text-domired-600 dark:hover:text-domired-400">
                {t('footer.about')}
              </Link>
              <Link to="/privacy" className="text-sm text-gray-600 dark:text-gray-400 hover:text-domired-600 dark:hover:text-domired-400">
                {t('footer.privacy')}
              </Link>
              <Link to="/terms" className="text-sm text-gray-600 dark:text-gray-400 hover:text-domired-600 dark:hover:text-domired-400">
                {t('footer.terms')}
              </Link>
              <Link to="/contact" className="text-sm text-gray-600 dark:text-gray-400 hover:text-domired-600 dark:hover:text-domired-400">
                {t('footer.contact')}
              </Link>
            </div>
            <div className="flex-shrink-0">
              <LanguageSelector />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
